import { useEffect } from 'react';

import useConfig from '@/hooks/useConfig.ts';

import { areAnalyticsEnabled, setCustomDimension } from '@/utils/analyticsUtils.ts';

// Local type declaration for globalThis._mtm
declare global {
    // eslint-disable-next-line @typescript-eslint/naming-convention
    var _mtm: Array<Record<string, unknown>> | undefined;
}

const useAnalytics = (): void => {
    const { selected_customer, selected_location } = useConfig();

    useEffect(() => {
        if (!areAnalyticsEnabled()) return;

        if (!globalThis._mtm) {
            globalThis._mtm = [];
        }

        globalThis._mtm.push({ 'mtm.startTime': Date.now(), event: 'mtm.Start' });
        const d = document;
        const g = d.createElement('script');
        const s = d.querySelectorAll('script')[0];
        g.async = true;
        g.src = import.meta.env.VITE_MATOMO_SRC;
        s.parentNode?.insertBefore(g, s);
    }, []);

    useEffect(() => {
        if (!areAnalyticsEnabled() || !selected_customer) return;

        setCustomDimension({ customer: selected_customer.customer_name });
    }, [selected_customer]);

    useEffect(() => {
        if (!areAnalyticsEnabled() || !selected_location) return;

        setCustomDimension({ location: selected_location.title });
    }, [selected_location]);
};

export default useAnalytics;
